/* eslint-disable no-unused-vars */
import { all, put, call, select, takeEvery } from 'redux-saga/effects';
import * as actions from 'redux/actions/billingAccountActions';
import { apolloQuery } from 'utils/apollo';
import { QUERY_BILLING_ACCOUNT_DATA } from 'utils/apollo/graphql/billingAccount';
import { QUERY_MEMBERSHIP_LIST } from 'utils/apollo/graphql/membership';
import { QUERY_DEVICE_LIST } from 'utils/apollo/graphql/device';

function* loadBillingAccount(action) {
	try {
		const { userid } = action.payload;
		const { data, errors } = yield call(async () => await apolloQuery(QUERY_BILLING_ACCOUNT_DATA));

		const projects = [];
		const devices = []

		yield* data.projectList.map(function* (project) {
			// get project membership
			const membershipQuery = yield call(
				async () => await apolloQuery(QUERY_MEMBERSHIP_LIST, { projectid: project.projectid })
			);

			if (membershipQuery.errors) throw membershipQuery.errors;

			const memberLevel = membershipQuery.data.membership.find((item) => item.userid === userid)?.level;
			if(memberLevel === 5 && project.tags?.A === 'handysense'){
				const deviceListQuery = yield call(
					async () =>  await apolloQuery(QUERY_DEVICE_LIST, {
						filter: { projectid: project.projectid, tags: { A: 'handysense' } }
					})
				)
				if (deviceListQuery.errors) throw deviceListQuery.errors;
				deviceListQuery.data.deviceList.forEach(device => {
					devices.push(device)
				});
			}

			projects.push({ ...project, level: memberLevel });

		});

		if (errors) {
			throw errors;
		} else {
			yield put(actions.loadBillingAccount.success({ billingAccount: data.billingAccount, projects,devices }));
		}
	} catch (error) {
		yield put(actions.loadBillingAccount.failure(error));
	}
}

export default function* watchBillingAccount() {
	yield all([takeEvery(actions.LOAD_BILLING_ACCOUNT.REQUEST, loadBillingAccount)]);
}
